import React from 'react'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

class CartDrawer extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			shoppingCartItems: [
				{
					title: 'Print Ethno Tank',
					sku: '7165370020001',
					desc:
						'Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis commodi esse nisi nobis deleniti ipsum? Eius similique vel perferendis minus.',
					price: 59.99,
					color: 'black',
					size: 'small',
					quantity: 2,
					image: 'https://placehold.it/150'
				},
				{
					title: 'Twill Summer Floral Shorts',
					sku: '7165370020001',
					desc:
						'Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis commodi esse nisi nobis deleniti ipsum? Eius similique vel perferendis minus.',
					price: 29.99,
					color: 'pink',
					size: 'medium',
					quantity: 1,
					image: 'https://placehold.it/150'
				},
				{
					title: 'Wave Gloss Purse',
					sku: '7165370020001',
					desc:
						'Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis commodi esse nisi nobis deleniti ipsum? Eius similique vel perferendis minus.',
					price: 129.99,
					color: 'black mix',
					size: 'one size',
					quantity: 1,
					image: 'https://placehold.it/150'
				}
			]
		}
	}

	handleAddCart(e) {
		e.preventDefault()
		this.setState(this.state.shoppingCartItems, {
			title: 'Topshop Floral',
			sku: '7165370020001',
			desc:
				'Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis commodi esse nisi nobis deleniti ipsum? Eius similique vel perferendis minus.',
			price: 49.99,
			color: 'pink',
			size: 'medium',
			quantity: 1,
			image: 'https://placehold.it/150'
		})
	}

	toggleCartDrawer() {
		const cartDrawerEl = document.querySelector('#cart-drawer')

		cartDrawerEl.classList.toggle('show')
		document.querySelector('body').classList.toggle('modal-open')
	}

	render() {
		return (
			<aside id='cart-drawer'>
				<div className='container'>
					<div className='row'>
						<div className='col-12' style={{ padding: '2.4rem' }}>
							<FAI
								icon='times'
								size='lg'
								onClick={this.toggleCartDrawer}
							/>
							<h3>Your Cart</h3>
							{this.state.shoppingCartItems.map((item, i) => {
								return (
									<div className='row cart-item' key={i}>
										<div className='col-12'>
											<img
												src={item.image}
												alt='placeholder'
											/>
										</div>
										<div className='col-12'>
											<h4>{item.title}</h4>
										</div>
										<div className='col-12'>
											<p>${item.price}</p>
										</div>
									</div>
								)
							})}
							<a
								href='/shopping-cart'
								className='btn btn--primary'>
								<span className='btn__text'>
									Go To Checkout
								</span>
							</a>
						</div>
					</div>
				</div>
			</aside>
		)
	}
}

export default CartDrawer
